<template>
  <div class="info-row">
    <div class="cost-key">{{ field }}:</div>
    <!-- <div class="cost-value">{{ value }}</div> -->
    <div class="cost-value" :style="beyondStyle">{{ displayValue }}</div>
  </div>
</template>

<script>
import dayjs from "dayjs";

const statusToText = {
  none: "无",
  dev: "开发中",
  supplying: "供货中",
  receive: "收尾款中",
  sue: "起诉中",
};
export default {
  name: "CustomerBasicInfoRow",
  props: ["value", "field", "type"],
  data() {
    return {};
  },
  computed: {
    displayValue: function () {
      switch (this.type) {
        case "string":
          if (this.value) {
            return this.value;
          } else {
            return "-";
          }
        case "object":
          if (this.value) {
            return this.value.name;
          } else {
            return "-";
          }
        case "array":
          if (this.value && this.value.length > 0) {
            const value = this.value.map((x) => x.name).join(",");
            return value;
          } else {
            return "-";
          }
        case "status":
          if (this.value) {
            return statusToText[this.value];
          } else {
            return "-";
          }
        case "dev":
          if (this.value && this.value === true) {
            return "是";
          } else if (this.value && this.value === false) {
            return "否";
          } else {
            return "-";
          }
        case "date":
          return this.value ? dayjs(this.value).format('YYYY-M-D') : '-'
      }
      const type = this.type;
    },
    beyondStyle: function () {
      if (this.field === "公司类型" || this.field === "经营范围") {
        const style = {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        };
        return style;
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.info-row
  display flex
  font-size 14px
  margin-bottom 5px
  max-width 400px

  .cost-key
    margin-right 6px
    color #858585
    min-width 60px
    text-align justify
    height 21px

  .cost-key:after
    content ''
    display inline-block
    width 100%
</style>